<template>
<div>
    <p v-if="name" class="player-title">{{name}}</p>
    <!-- <vue-plyr>
    </vue-plyr>   -->
        <audio controls playsinline :src="src || currSrc" ref="audio">
        </audio>

</div>
</template>

<script>
export default {
    name:"Player",
    data(){
        return {
            name:"",
            src:""
        }
    },
    props:{
        // 2026-09-29：详情页预先设置试听地址，但播放器不会自动开始；
        // 用户点击原生播放控件，或页面明确调用 play() 时才会出声。
        currSrc:{
            type:String,
            default:""
        }
    },
    methods:{
        play(opt){
            //强制重新播放
            this.name = opt.name;
            this.src = opt.src
            this.$nextTick(()=>{
                //设置播放时间到0
                this.$refs.audio.currentTime = 0
                this.$refs.audio.play()
            })
        }
    }
}
</script>

<style scoped>
.player-title {
    margin: 0 0 8px;
    color: #606266;
}

audio {
    display: block;
}
</style>
